import React, { useEffect, useState } from "react";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import {
  macroStateOptionList,
  macroUserEventReceiver,
  macroUserEventTrigger,
} from "./macrostate";
import { IPartyDetailMemberInfo } from "../PartyDetailMemberInfo";
import styled from "styled-components";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Loader from "../../../../DefaultStyles/Loader";

interface Props extends DefaultModalCommonProps {
  memberData: {
    current: IPartyDetailMemberInfo[];
    ex: IPartyDetailMemberInfo[];
  };
}

export default function MacroStateChangeModal({
  closeEvent,
  memberData,
}: Props) {
  const { partyId } = useParams();

  const [triggerOptionList, setTriggerOptionList] = useState<OptionType[]>([]);
  const [receiverList, setReceiverList] = useState<OptionType[]>([]);
  const [isChangeSuccess, setIsChangeSuccess] = useState(false);
  const [state, setState] = useState<OptionType>({
    value: "",
    label: "매크로 상태 선택",
  });
  const [target, setTarget] = useState<OptionType>({
    value: "",
    label: "대상 선택",
  });
  const [fetch, setFetch] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: fetch ? "party/macro" : undefined,
    data: {
      partyid: partyId ? +partyId ?? 0 : 0,
      uid: target.value ? +target.value ?? 0 : 0,
      macro: state.value ? +state.value ?? 0 : 0,
      type: false,
    },
  });

  useEffect(() => {
    if (state.value !== "") {
      const isExitMember = macroUserEventTrigger(+state.value!) === "exit_mbr";
      const isExitLdr = macroUserEventTrigger(+state.value!) === "exit_ldr";
      const isLdr = macroUserEventTrigger(+state.value!) === "ldr";

      const filtered = isExitMember
        ? memberData?.ex?.filter((m) => m.grade === 1)
        : isExitLdr
        ? memberData?.ex?.filter((m) => m.grade !== 1)
        : isLdr
        ? memberData?.current?.filter((m) => m.grade !== 1)
        : memberData?.current?.filter((c) => c.grade === 1);

      console.log(filtered);

      const list = filtered?.map((f) => ({
        value: f.uid,
        label: `${f.uid}_${f.name}_${f.nickname} (${
          f.grade === 1 ? "파티원" : "파티장"
        })${isExitMember ? "(탈퇴)" : ""}`,
      }));

      setTriggerOptionList(list);
    }
  }, [memberData, state.value]);

  useEffect(() => {
    if (target.value !== "" && state.value !== "") {
      const filtered =
        macroUserEventReceiver(+state.value!) === "ldr,mbr"
          ? memberData?.current?.filter(
              (f) => f.uid === target.value || f.grade !== 1
            )
          : memberData?.current?.filter((c) =>
              macroUserEventReceiver(+state.value!) === "mbr"
                ? c.uid === target.value
                : c.grade !== 1
            );

      const list = filtered?.map((f) => ({
        value: f.uid,
        label: `${f.uid}_${f.name}_${f.nickname} (${
          f.grade === 1 ? "파티원" : "파티장"
        })`,
      }));

      setReceiverList(list);
    }
  }, [target.value, state.value]);

  useEffect(() => {
    if (response?.status === 200) setIsChangeSuccess(true);
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "매크로 상태 변경에 실패했습니다.");
      setFetch(false);
    }
  }, [error]);

  return (
    <DefaultModalLayout
      modalTitle={
        isChangeSuccess ? "매크로 상태 변경 성공" : "매크로 상태 변경"
      }
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        if (isChangeSuccess) return closeEvent();

        setFetch(true);
      }}
      cancelBtnText="취소"
      confirmBtnText={isChangeSuccess ? "확인" : "변경"}
      isMediumModal
      cancelBtn={isChangeSuccess ? <></> : undefined}
    >
      {/* 상태 선택 */}
      <ModalRow>
        <ModalLabel>상태 선택</ModalLabel>

        <ModalRowContentContainer>
          {isChangeSuccess ? (
            <Receiver style={{ width: "100%" }}>{state.label}</Receiver>
          ) : (
            <DropDown
              dropdownValue={state}
              setDropDownValue={setState}
              boxWidth={330}
              optionList={macroStateOptionList(
                Boolean(memberData?.ex?.length > 0)
              )}
            />
          )}
        </ModalRowContentContainer>
      </ModalRow>

      {/* 트리거 선택 */}
      <ModalRow>
        <ModalLabel>트리거 선택</ModalLabel>

        <ModalRowContentContainer>
          {isChangeSuccess ? (
            <Receiver style={{ width: "100%" }}>{target.label}</Receiver>
          ) : (
            <DropDown
              dropdownValue={target}
              setDropDownValue={setTarget}
              boxWidth={330}
              optionList={triggerOptionList}
              isDisabled={state.value === ""}
            />
          )}
        </ModalRowContentContainer>
      </ModalRow>

      {/* 수신자 */}
      {target.value !== "" ? (
        <ModalRow>
          <ModalLabel>수신자</ModalLabel>

          <ModalRowContentContainer>
            <ReceiverContainer>
              {receiverList?.map((r, i) => (
                <Receiver key={i}>{r.label}</Receiver>
              ))}
            </ReceiverContainer>
          </ModalRowContentContainer>
        </ModalRow>
      ) : (
        <></>
      )}

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}

const ReceiverContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Receiver = styled.div`
  padding: 10px 16px;
  border-radius: 3px;
  background-color: #f6f6f8;
  font-size: 14px;
  font-weight: 500;
  color: #808080;
  line-height: 1.5;
`;
